import { render, staticRenderFns } from "./shop-dual-auto-complete.vue?vue&type=template&id=61e5109a"
import script from "./shop-dual-auto-complete.vue?vue&type=script&lang=js"
export * from "./shop-dual-auto-complete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports